import React from "react";
import { Box, Typography } from "@mui/material";
import theme from "../../configs/theme";

export default function BalanceUI({ balance }) {
  return (
    <Box
      sx={{
        borderRadius: 2,
        bgcolor: theme.tableColors.header,
        p: 1,
      }}
    >
      <Typography fontWeight="bold" fontSize="18px" gutterBottom>
        Balance Mensual
      </Typography>
      <Typography
        variant="body1"
        sx={{
          fontWeight: "bold",
          fontSize: "14px",
          color: balance >= 0 ? "green" : "red",
        }}
      >
        Balance: $ {balance}
      </Typography>
    </Box>
  );
}
